import { render, staticRenderFns } from "./fjsPoster.vue?vue&type=template&id=0b182f25&scoped=true"
import script from "./fjsPoster.vue?vue&type=script&lang=js"
export * from "./fjsPoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b182f25",
  null
  
)

export default component.exports